import React from 'react';

const MenuWhiteIcon = () => (
        <svg width="24px" height="16px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Landing-page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
                <g id="Homepage-/-Mobile" transform="translate(-312.000000, -27.000000)" stroke="#FFFFFF" strokeWidth="1.4">
                    <path d="M312,27.7272727 L336,27.7272727 L312,27.7272727 Z M312,42.2727273 L336,42.2727273 L312,42.2727273 Z M312,35 L336,35 L312,35 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </svg>
)

export default MenuWhiteIcon;